// sensei-app/client/ui/ClassroomWhiteboard.js
import { ComponentBase } from "../../core/ComponentBase.js";
import { marked } from "https://cdn.jsdelivr.net/npm/marked/lib/marked.esm.js";
// We will lazy-load mermaid only when needed.

export class ClassroomWhiteboard extends ComponentBase {
    static styles = `
        .classroom-whiteboard {
            flex-grow: 1;
            padding: 1.5rem;
            overflow-y: auto;
            background-color: var(--bs-body-bg);
        }
        .whiteboard-content h1, .whiteboard-content h2 {
            border-bottom: 1px solid var(--bs-border-color-translucent);
            padding-bottom: 0.5rem;
            margin-top: 1.5rem;
        }
        .whiteboard-content pre {
            background-color: var(--bs-tertiary-bg);
            padding: 1rem;
            border-radius: var(--bs-border-radius);
        }
        .whiteboard-content img {
            max-width: 100%;
            height: auto;
            border-radius: var(--bs-border-radius);
            margin-top: 1rem;
        }
    `;

    constructor(config) {
        super(config);
        this.mermaidLoaded = false;
        this.applyStyles();
    }

    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'classroom-whiteboard';
            this.container.innerHTML = `<div class="whiteboard-content"></div>`;
        }
        return this.container;
    }

    async setContent(contentObject) {
        const contentArea = this.container.querySelector('.whiteboard-content');
        if (!contentArea) return;

        const contentHtml = await this.generateContentHtml(contentObject);

        // Always replace the content, as we are streaming the full buffer each time.
        contentArea.innerHTML = contentHtml;

        // Scroll to the bottom of the whiteboard content as it grows
        this.container.scrollTop = this.container.scrollHeight;

        if (contentArea.querySelectorAll('.mermaid').length > 0) {
            await this.renderMermaidDiagrams();
        }
    }


    async generateContentHtml(contentObject) {
        switch (contentObject.contentType) {
            case 'markdown':
                return marked.parse(contentObject.content);
            case 'image':
                return `<img src="${contentObject.content}" alt="Classroom Image">`;
            case 'mermaid':
                return `<div class="mermaid">${contentObject.content}</div>`;
            default:
                return `<p>${this.t('Unsupported content type.')}</p>`;
        }
    }

    async loadMermaidScript() {
        if (window.mermaid) {
            this.mermaidLoaded = true;
            return;
        }
        if (this.loadingMermaid) return this.loadingMermaid;

        this.loadingMermaid = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/mermaid@10/dist/mermaid.min.js';
            script.onload = () => {
                this.mermaidLoaded = true;
                resolve();
            };
            script.onerror = reject;
            document.head.appendChild(script);
        });
        return this.loadingMermaid;
    }

    async renderMermaidDiagrams() {
        if (!this.mermaidLoaded) {
            await this.loadMermaidScript();
            mermaid.initialize({
                startOnLoad: false, theme: 'base', themeVariables: {
                    'primaryColor': getComputedStyle(document.documentElement).getPropertyValue('--bs-primary-bg-subtle').trim(),
                    'primaryTextColor': getComputedStyle(document.documentElement).getPropertyValue('--bs-emphasis-color').trim(),
                    'lineColor': getComputedStyle(document.documentElement).getPropertyValue('--bs-border-color').trim(),
                    'textColor': getComputedStyle(document.documentElement).getPropertyValue('--bs-body-color').trim(),
                }
            });
        }
        await mermaid.run({
            nodes: this.container.querySelectorAll('.mermaid')
        });
    }
}